import { createPdfLineById } from "../shared";

export const INVEST_CO_MAIN_COMP_LINES = [
  {
    id: "net_investment_income",
    label: "Net Investment Income",
    type: "section",
  },
  {
    id: "total_investment_income",
    label: "Total Net Investment Income",
    type: "result",
  },
  {
    id: "current_year_ca",
    label: "Less: Current Year Capital Allowances",
    type: "section",
  },
  {
    id: "current_year_donations",
    label: "Less: Current Year Donations",
    type: "section",
  },
  {
    id: "current_year_losses",
    label: "Less: Current Year Losses",
    type: "section",
  },
  {
    id: "chargeable_income_before_exempt_amount",
    label: "Chargeable Income Before Exempt Amount",
    type: "result",
  },
];

export const INVEST_CO_MAIN_COMP_LINE_BY_ID = createPdfLineById(
  INVEST_CO_MAIN_COMP_LINES
);
